// extracted by mini-css-extract-plugin
export var readonly = "_ic-1";
export var star = "_ic-0";